export default "__VITE_ASSET__CHCmHL2q__"